import { Icon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Select,
  Text,
  Textarea,
} from "@chakra-ui/react";
import { FaFileExport, FaSave } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useRecoilState, useSetRecoilState } from "recoil";
import {
  BLUEMONEDDBACKGROUND,
  BLUEMONEDDBUTTONS,
  REDMONEDD,
} from "../../../../constants/colors";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { toast } from "react-toastify";
import { goToListFavorites, goToSuport } from "../../../../routes/coordinator";
import { refreshGlobal } from "../../../../atoms/refreshGlobal";
import { componentState } from "../../../../atoms/componentState";
import { useEffect, useState } from "react";
import FavoritesAPi from "../../../../services/favoritesApi";
import { cnpj as cnpjValidator, cpf as cpfValidator } from "cpf-cnpj-validator";
import SysTypesApi from "../../../../services/sysTypesApi";
import { NumericFormat, PatternFormat } from "react-number-format";
import BankSelector from "../../../../defaultComponents/bankSelector";
import { LoggedUser } from "../../../../atoms/userLogged";
import { JWTToken } from "../../../vendas/listaDeVendas/components/SalesList";
import jwt_decode from "jwt-decode";
import TipoServicoSelect from "../defaultComponents/tipoServicoSelect";
import { dateForAPI } from "../../../../constants/dataFormat";
import moment from "moment"
import { validateFields } from "../../../../defaultFunctions/validators";
import ClientApi from "../../../../services/clientApi";
import SuportSolicitationsAPI from "../../../../services/servicosSolicitacoesApi";
import POSSelect from "../../../../defaultComponents/POSSelect";
import { selectedClientHeader } from "../../../../atoms/selectedClientHeader";

const bobinas = [
    {qtde: "1 bobina(s)",
    id: 1,},
    {qtde: "2 bobina(s)",
    id: 2,},
    {qtde: "3 bobina(s)",
    id: 3,},
    {qtde: "4 bobina(s)",
    id: 4,},
    {qtde: "5 bobina(s)",
    id: 5,},
    {qtde: "6 bobina(s)",
    id: 6,},
    {qtde: "7 bobina(s)",
    id: 7,},
    {qtde: "8 bobina(s)",
    id: 8,},
    {qtde: "9 bobina(s)",
    id: 9,},
    {qtde: "10 bobina(s)",
    id: 10,},
]

const servicoList = [
    {qtde: "Custo de TED",
    id: 1,},
    {qtde: "Problemas com TED",
    id: 2,},
    {qtde: "Tabelas e taxas",
    id: 3,},
    {qtde: "Taxas",
    id: 4,},
    {qtde: "Outras",
    id: 5,},
    {qtde: "Problemas com pagamento",
    id: 6,}
]

export default function AddSuport() {
    const navigate = useNavigate();
    const token = window.localStorage.getItem("token");
    let jwtToken: JWTToken = jwt_decode(token || "");
    // const cliente = Number(jwtToken.idCliente);
    const user = useRecoilState(LoggedUser)[0];
    const selectedId = useRecoilState(selectedClientHeader)[0];
    const cliente = user.idLoginTipo === 4 ? Number(jwtToken.idCliente) : Number(selectedId);
    const setRefreshGlobal = useSetRecoilState(refreshGlobal);
    const refresh = useRecoilState(refreshGlobal)[0];
    const setHeaderLocation = useSetRecoilState(componentState);
    const [idTipoServico, setIdTipoServico] = useState(0);
    const [codigoPOS, setCodigoPOS] = useState("")

    useEffect(() => {
        setHeaderLocation("Nova Solicitação");
        getAddressClient();
    }, []);

    interface IFormInputs {
        idTipoServico: number,
        idCliente: number,
        idServicoStatus: number,
        funcionamento: string,
        endereco: string,
        numero: string,
        complemento: string,
        bairro: string,
        referencia: string,
        cidade: string,
        uf: string,
        cep: string,
        observacao: string,
        serialPOS: string,
        qtdBobinas: number,
        servico: string,
        data: string
    }

    const schema = yup
        .object({
        nome: yup
            .string()
            .required("O nome da empresa deve ser preenchido")
            .min(5, "O nome da empresa deve conter mais de 5 caracteres")
            .max(100, "O nome da empresa não pode conter mais de 100 caracteres"),
        })
        .required();

    const {
        register,
        handleSubmit,
        watch,
        setError,
        formState: { errors },
    } = useForm<IFormInputs>({ resolver: yupResolver(schema) });

    const initialValues = {
        idTipoServico: 0,
        idCliente: cliente,
        idServicoStatus: 0,
        funcionamento: "",
        endereco: "",
        numero: "",
        complemento: "",
        bairro: "",
        referencia: "",
        cidade: "",
        uf: "",
        cep: "",
        observacao: "",
        serialPOS: "",
        qtdBobinas: 0,
        servico: "",
        data: ""
    };
    const [servico, setServico] = useState<IFormInputs>(initialValues);

    async function getAddressClient () {
        try {
            const response: any = await ClientApi.getClientPerId(cliente);
            setServico((s: any) => ({...s, 
                endereco: response.enderRua,
                numero: response.enderNumero,
                complemento: response.enderComplemento,
                bairro: response.enderBairro,
                cidade: response.enderMunicipio,
                uf: response.enderUF,
                cep: response.enderCep,
            }))
        } catch (error) {
            console.log(error)
        }
    }

    async function addServico(obj: {}) {
        try {
            const response = await SuportSolicitationsAPI.postSuporte(obj);
            toast.success("Pedido de suporte enviado com sucesso!");
            setRefreshGlobal(refresh + 1);
            goToSuport(navigate);
        } catch (error) {
            toast.error("Não foi possível enviar o pedido de suporte.");
            console.log(error);
        }
    }

    async function onSubmit(obj: any   ) {
        const servico = idTipoServico !== 3 ? "" : obj.servico; 

        const objeto = {
            idTipoServico: idTipoServico,
            idCliente: cliente,
            idServicoStatus: 1,
            funcionamento: servico !== "" ? null : obj.funcionamento,
            endereco: servico !== "" ? null : obj.endereco,
            numero: servico !== "" ? null : obj.numero,
            complemento: servico !== "" ? null : obj.complemento,
            bairro: servico !== "" ? null : obj.bairro,
            referencia: servico !== "" ? null : obj.referencia,
            cidade: servico !== "" ? null : obj.cidade,
            uf: servico !== "" ? null : obj.uf,
            cep: servico !== "" ? null : obj.cep,
            observacao: obj.observacao,
            serialPOS: idTipoServico !== 2 ? null : codigoPOS,
            qtdBobinas: idTipoServico !== 1 ? null : Number(obj.qtdBobinas),
            servico: idTipoServico !== 3 ? null : obj.servico,
            data: moment(Date.now()).format(dateForAPI)
        };

        // console.log("servico", objeto)

        if(validateFields({idTipoServico: objeto.idTipoServico})){
            // console.log("entrei", objeto );
            addServico(objeto);
        }
    }

    const unMask = (value: any) => {
        return value.replace(/[^0-9]/g, "");
    };

    const [types, setTypes] = useState([
        {
        id: 0,
        nome: "",
        },
    ]);

    const getTypeAccount = async () => {
        try {
        const response = await SysTypesApi.sysTypeAccount(1, 100, "");
        setTypes(response);
        } catch (error: any) {
        console.log(error);
        }
    };

    useEffect(() => {
        getTypeAccount();
    }, []);

    return (
        <>
            <Flex
                w={"100%"}
                h={"100%"}
                alignItems="center"
                justifyContent="center"
                bg={"#F1F1F1"}
            >
                <Flex
                    w={"95%"}
                    h={"95%"}
                    bgColor={BLUEMONEDDBACKGROUND}
                    borderRadius={"20px"}
                    justifyContent="center"
                    alignItems={"center"}
                >
                    <Flex
                        w={"90%"}
                        height="90%"
                        flexDirection={"column"}
                        justifyContent="space-evenly"
                    >
                        <Text fontWeight={"bold"} fontSize="35px" color={"white"}>
                            NOVA SOLICITAÇÃO
                        </Text>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <FormControl >
                                <FormLabel color="white">
                                    Tipo de Serviço
                                </FormLabel>
                                <Box borderRadius={"6px"} bgColor={"white"} w="100%">
                                    <TipoServicoSelect idSelect={idTipoServico} setIdSelect={setIdTipoServico}/>
                                </Box>
                                <Text color="red" mb={2}>
                                    {errors.idTipoServico?.message}
                                </Text>
                            </FormControl>
                            <Flex w="100%" justifyContent={"space-between"} alignContent={"center"}>
                                <FormControl 
                                    w={"48%"}
                                    mx={1}
                                >
                                    <FormLabel color="white">
                                        {
                                            idTipoServico === 1 || (idTipoServico !== 2 && idTipoServico !== 3) ? 
                                                `Quantidade de bobinas`
                                                :
                                                idTipoServico === 2 ? 
                                                    `Máquina`
                                                    :
                                                    `Serviço`
                                        }
                                    </FormLabel>
                                    {
                                        idTipoServico === 1 || (idTipoServico !== 2 && idTipoServico !== 3) ? 
                                            <Box borderRadius={"6px"} bgColor={"white"}>
                                                <Select  onChange={(e: any) => setServico({...servico, qtdBobinas: e.target.value})}>
                                                    <option selected disabled>Selecione...</option> 
                                                    {bobinas && bobinas.map((bobina: any) => {
                                                            return (
                                                                <option key={bobina.id} value={bobina.id}>{bobina.qtde}</option>
                                                            )
                                                    })}
                                                </Select>   
                                            </Box>
                                            :
                                            idTipoServico === 2 ? 
                                                <Box borderRadius={"6px"} bgColor={"white"}>
                                                    <POSSelect idSelect={codigoPOS} setIdSelect={setCodigoPOS} idCliente={cliente}/>
                                                </Box>
                                                :
                                                <Box borderRadius={"6px"} bgColor={"white"}>
                                                    <Select  onChange={(e: any) => setServico({...servico, servico: e.target.value})}>
                                                        <option selected disabled>Selecione...</option> 
                                                        {servicoList && servicoList.map((bobina: any) => {
                                                                return (
                                                                    <option key={bobina.qtde} value={bobina.qtde}>{bobina.qtde}</option>
                                                                )
                                                        })}
                                                    </Select>   
                                                </Box>
                                    }
                                    {/* <Text color="red" mt="-3" mb={2}>
                                        {errors.qtdBobinas?.message}
                                    </Text> */}
                                </FormControl>
                                {
                                    idTipoServico !== 3 ? 
                                        <>
                                            
                                            <FormControl w="48%">
                                                <FormLabel color="white">Horário e Dias de Funcionamento</FormLabel>
                                                <Input
                                                    mb={2}
                                                    type="text"
                                                    bg="white"
                                                    placeholder="Digite horário e dias de funcionamento"
                                                    onChange={(e: any) => {
                                                        setServico({ ...servico, funcionamento: e.target.value });
                                                    }}
                                                />
                                                <Text color="red" mb={2}>
                                                    {errors.funcionamento?.message}
                                                </Text>
                                            </FormControl>
                                        </>
                                        :
                                        <></>
                                }
                                
                            </Flex>
                            {
                                    idTipoServico !== 3 ? 
                                        (
                                            <>
                                                <Flex w="100%" justifyContent={"space-between"}>
                                                    <FormControl w="35%" mx={1}>
                                                        <FormLabel color="white">Endereço</FormLabel>
                                                        <Input
                                                            mb={2}
                                                            type="text"
                                                            bg="white"
                                                            value={servico.endereco}
                                                            placeholder="Digite o endereço"
                                                            onChange={(e: any) => {
                                                                setServico({ ...servico, endereco: e.target.value });
                                                            }}
                                                        />
                                                    </FormControl>
                                                    <FormControl w="15%" mx={1}>
                                                        <FormLabel color="white">Número</FormLabel>
                                                        <NumericFormat
                                                            customInput={Input}
                                                            mb={2}
                                                            type="text"
                                                            allowNegative={false}
                                                            value={servico.numero}
                                                            bg="white"
                                                            placeholder="Digite o número"
                                                            onChange={(e: any) => {
                                                                setServico({ ...servico, numero: e.target.value });
                                                            }}
                                                        />
                                                        <Text color="red" mb={2}>
                                                            {errors.numero?.message}
                                                        </Text>
                                                    </FormControl>
                                                    <FormControl w="30%" mx={1}>
                                                        <FormLabel color="white">
                                                            Complemento
                                                        </FormLabel>
                                                        <Input
                                                            bg="white"
                                                            type="text"
                                                            placeholder="Digite o número da conta"
                                                            value={servico.complemento}
                                                            // {...register("nroConta", { required: true })}
                                                            onChange={(e: any) => {
                                                                setServico({
                                                                    ...servico,
                                                                    complemento: e.target.value,
                                                                });
                                                            }}
                                                        />
                                                    </FormControl>
                                                    <FormControl w="35%" mx={1}>
                                                        <FormLabel color="white">
                                                            Bairro
                                                        </FormLabel>
                                                        <Input
                                                            bg="white"
                                                            type="text"
                                                            
                                                            placeholder="Digite o bairro"
                                                            value={servico.bairro}
                                                            // {...register("nroConta", { required: true })}
                                                            onChange={(e: any) => {
                                                                setServico({
                                                                    ...servico,
                                                                    bairro: e.target.value,
                                                                });
                                                            }}
                                                        />
                                                    </FormControl>
                                                </Flex>
                                                <Flex w="100%" justifyContent={"space-between"}>
                                                    <FormControl w="35%" mx={1}>
                                                        <FormLabel color="white">Referência</FormLabel>
                                                        <Input
                                                            mb={2}
                                                            type="text"
                                                            bg="white"
                                                            value={servico.referencia}
                                                            placeholder="Digite a referência"
                                                            onChange={(e: any) => {
                                                                setServico({ ...servico, referencia: e.target.value });
                                                            }}
                                                        />
                                                    </FormControl>
                                                    <FormControl w="30%" mx={1}>
                                                        <FormLabel color="white">Cidade</FormLabel>
                                                        <Input
                                                            mb={2}
                                                            type="text"
                                                            bg="white"
                                                            placeholder="Digite a cidade"
                                                            value={servico.cidade}
                                                            onChange={(e: any) => {
                                                                setServico({ ...servico, cidade: e.target.value });
                                                            }}
                                                        />
                                                        <Text color="red" mb={2}>
                                                            {errors.cidade?.message}
                                                        </Text>
                                                    </FormControl>
                                                    <FormControl w="15%" mx={1}>
                                                        <FormLabel color="white">
                                                            UF
                                                        </FormLabel>
                                                        <Input
                                                            bg="white"
                                                            type="text"
                                                            placeholder="Digite a UF"
                                                            value={servico.uf}
                                                            // {...register("nroConta", { required: true })}
                                                            onChange={(e: any) => {
                                                                setServico({
                                                                    ...servico,
                                                                    uf: e.target.value,
                                                                });
                                                            }}
                                                        />
                                                    </FormControl>
                                                    <FormControl w="20%" mx={1}>
                                                        <FormLabel color="white">
                                                            Cep
                                                        </FormLabel>
                                                        <Input
                                                            bg="white"
                                                            type="text"
                                                            
                                                            placeholder="Digite o cep"
                                                            value={servico.cep}
                                                            // {...register("nroConta", { required: true })}
                                                            onChange={(e: any) => {
                                                                setServico({
                                                                    ...servico,
                                                                    cep: e.target.value,
                                                                });
                                                            }}
                                                        />
                                                    </FormControl>
                                                </Flex>
                                            </>
                                        )
                                        :
                                        <></>
                            }
                            <Flex w="100%" justifyContent={"space-between"}>
                                <FormControl mx={1}>
                                    <FormLabel color="white">Observações</FormLabel>
                                    <Textarea
                                        mb={2}
                                        bg="white"
                                        placeholder="Observações..."
                                        value={servico.observacao}
                                        onChange={(e: any) => {
                                            setServico({ ...servico, observacao: e.target.value });
                                        }}
                                    />
                                </FormControl>
                            </Flex>
                            <Flex justifyContent={"space-between"} w="25%">
                                <Button
                                    type="submit"
                                    bgColor={BLUEMONEDDBUTTONS}
                                    color="white"
                                    isDisabled={
                                        (
                                            idTipoServico === 1 && servico.qtdBobinas !== 0 ||
                                            idTipoServico === 2 && codigoPOS !== '' ||
                                            idTipoServico === 3 && servico.servico !== '' 
                                        ) &&
                                        Number(idTipoServico) != 0 && 
                                        cliente > 0
                                        ? false
                                        : true
                                    }
                                    onClick={() => {
                                        onSubmit(servico);
                                    }}
                                >
                                <Icon mr={2} as={FaSave} />
                                    SALVAR
                                </Button>
                                <Button
                                bgColor={REDMONEDD}
                                color="white"
                                onClick={() => goToSuport(navigate)}
                                >
                                X CANCELAR
                                </Button>
                            </Flex>
                        </form>
                    </Flex>
                </Flex>
            </Flex>
        </>
    );
}
